import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useFocusOnMount from '../../hooks/useFocusOnMount';
import Button from '../../components/common/Button';
import CharacterProfileContent from './CharacterProfileContent';
import s from './CharacterProfilePage.module.css';

export default function CharacterProfilePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useFocusOnMount();
  const character = location.state?.character || null;

  useEffect(() => {
    if (!character) navigate('/workbook', { replace: true });
  }, [character, navigate]);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  if (!character) return null;

  return (
    <main className={s.page} ref={mainRef} tabIndex={-1}>
      <div className={s.backRow} style={{ padding: '15px var(--space-200) 0' }}>
        <Button variant="back" onClick={() => navigate(-1)}>
          {t('common.back')}
        </Button>
      </div>
      <CharacterProfileContent
        character={character}
        onClose={() => navigate(-1)}
      />
    </main>
  );
}
